module.exports = __webpack_public_path__ + "img/icon_adopta.b5cd3642.svg";